export default __webpack_public_path__ + "static/media/zxc.e52a98d0.png";